import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountId", "selectedUsers"];
import { useHubSpotterUsersForAccount } from '../playlistAssignmentsQueries';
import formatName from 'I18n/utils/formatName';
import { useEffect, useMemo, useRef } from 'react';
import Raven from 'raven-js';
import { Select } from 'foundations-components/transitional/components/Select';
import FormattedMessage from 'I18n/components/FormattedMessage';
import debounce from 'react-utils/debounce';
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
const PAGE_SIZE = 20;
const SEARCH_DEBOUNCE_TIME = 800;
export const HubSpotterAccountUsersSelect = _ref => {
  let {
      accountId,
      selectedUsers
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    usersForAccountLoading,
    refetchUsersForAccount
  } = useHubSpotterUsersForAccount({
    accountId
  });
  const selectedUsersOptions = useMemo(() => {
    if (!selectedUsers) {
      return [];
    }
    return selectedUsers.map(user => ({
      value: String(user.id),
      text: formatName(user)
    }));
  }, [selectedUsers]);
  const accumulatedResults = useRef({});
  useEffect(() => {
    accumulatedResults.current = {};
  }, [accountId]);
  const debouncedLoadOptions = useMemo(() => debounce(async (query, callback, pagination = {
    offset: 0
  }) => {
    try {
      const newUsers = await refetchUsersForAccount({
        query,
        offset: pagination.offset
      });
      const newResults = Object.assign({}, accumulatedResults.current);
      newUsers.result.results.forEach(user => {
        newResults[user.userId] = formatName(user);
      });
      accumulatedResults.current = newResults;
      const newOptions = Object.entries(newResults).map(([value, text]) => ({
        value,
        text
      }));
      callback(null, {
        options: newOptions,
        pagination: {
          hasMore: newUsers.result.hasMore,
          length: newUsers.result.total,
          offset: pagination.offset + PAGE_SIZE
        }
      });
    } catch (e) {
      Raven.captureException(e);
    }
  }, SEARCH_DEBOUNCE_TIME), [refetchUsersForAccount]);
  useEffect(() => {
    return () => {
      debouncedLoadOptions.reset();
    };
  }, [debouncedLoadOptions]);
  return /*#__PURE__*/_createElement(Select, Object.assign({}, props, {
    anchorType: "button",
    isLoading: usersForAccountLoading
    // Reset the state when the account changes and we want to load new users
    ,
    key: accountId,
    loadOptions: debouncedLoadOptions,
    multi: true,
    multiCollapseLimit: 10,
    options: selectedUsersOptions,
    placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "academyCommon.playlists.selectTeamMemberPlaceholder"
    })
  }));
};